import React from 'react'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../common/RequiredInputs'

const ProfileForm = (
    {
        inputs,
        handleChange,
        isDisable,
        textBtn,
        handleSubmit
    }
) => {

    return (
        <div className="task__container">
            <Form onSubmit={handleSubmit}>
                <div className="row col-12 mt-50 mb-30 form__container">
                    <div className="col-12 col-md-4">
                        <Form.Group size="lg">
                            <Form.Label className="form__labels">Contraseña actual <RequieredInputs/></Form.Label>
                            <Form.Control className="user-input login"
                                type="password"
                                value={inputs.passwordOld}
                                name="passwordOld"
                                onChange={handleChange}
                                placeholder="Contraseña actual"
                            />
                        </Form.Group>
                    </div>
                    <div className="col-12 col-md-4">
                        <Form.Group size="lg">
                            <Form.Label className="form__labels">Nueva contraseña <RequieredInputs/></Form.Label>
                            <Form.Control className="user-input login"
                                type="password"
                                name="passwordNew"
                                value={inputs.passwordNew}
                                onChange={handleChange}
                                placeholder="Nueva contraseña"
                            />
                        </Form.Group>
                    </div>
                    <div className="col-12 col-md-4">
                        <Form.Group size="lg">
                            <Form.Label className="form__labels">Repetir contraseña <RequieredInputs/></Form.Label>
                            <Form.Control className="user-input login"
                                type="password"
                                name="repeatPassword"
                                value={inputs.repeatPassword}
                                onChange={handleChange}
                                placeholder="Repetir contraseña"
                            />
                        </Form.Group>
                    </div>
                 </div> 
                 <button
                    disabled={isDisable}
                    onClick={handleSubmit}
                    className="btn save"
                >
                    {textBtn}
                </button>
            </Form>
        </div>
    )
}

export default ProfileForm